<mat-card class="checklist-card">
    <mat-card-header class="checklist-header">
        <mat-card-title>{{ 'GOAL_CHECKLIST.TITLE' | translate }}</mat-card-title>
        <mat-icon *ngIf="hasWarning" class="head-icon warning-icon" fontSet="material-icons-outlined" title="{{ 'GOAL_CHECKLIST.MISSING' | translate }}">info</mat-icon>
        <mat-icon *ngIf="!hasWarning" class="head-icon success-icon" fontSet="material-icons-outlined" title="{{ 'GOAL_CHECKLIST.DONE' | translate }}">check_circle</mat-icon>
    </mat-card-header>

    <mat-card-content class="checklist-content">
            <div *ngFor="let item of checklistItems" class="check-item-row" [ngClass]="item.isComplete ? 'status-complete' : 'status-missing'" [matTooltip]="item.tooltipKey | translate" [matTooltipDisabled]="!item.tooltipKey">
                <div class="check-info">
                    <mat-icon class="status-icon success-icon" fontSet="material-icons-outlined" *ngIf="item.isComplete">check_circle</mat-icon>
                    <img src="/assets/img/icons/error.svg" class="status-icon warning-icon" alt="warning" *ngIf="!item.isComplete" width="20" height="20">

                    <span class="check-label">{{ item.labelKey | translate }}</span>
                </div>
                <div class="check-counter">
                    {{ item.completed }}/{{ item.total }}
                </div>
            </div>

    </mat-card-content>
    <mat-card-footer>
        <div class="checklist-legend">
            <div class="legend-item">
                <span class="legend-dot dot-missing"></span>
                <span>{{ 'GOAL_CHECKLIST.MISSING' | translate }}</span>
            </div>
            <div class="legend-item">
                <span class="legend-dot dot-complete"></span>
                <span>{{ 'GOAL_CHECKLIST.DONE' | translate }}</span>
            </div>
        </div>
    </mat-card-footer>
</mat-card>
